import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/spm-ui-upgrade-helper/spm-ui-upgrade-helper/packages/gatsby-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Complete the following steps to configure and run the tool and to review and implement any required changes.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Run `}<inlineCode parentName="p">{`docker login`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Download the appropriate batch file or shell script for your environment:`}</p>
        <p parentName="li">{`Windows ™️`}</p>
        <p parentName="li"><inlineCode parentName="p">{`curl -L https://raw.githubusercontent.com/IBM/spm-ui-upgrade-helper/main/spm-ui-upgrade-helper.bat -o spm-ui-upgrade-helper.bat`}</inlineCode></p>
        <p parentName="li">{`Linux ®️`}</p>
        <p parentName="li"><inlineCode parentName="p">{`curl -L https://raw.githubusercontent.com/IBM/spm-ui-upgrade-helper/main/spm-ui-upgrade-helper.sh -o spm-ui-upgrade-helper.sh`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`(Linux®️ only) Make the shell script executable with `}<inlineCode parentName="p">{`chmod +x spm-ui-upgrade-helper.sh`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Download the docker-compose.yml file:`}</p>
        <p parentName="li">{`Windows ™️`}</p>
        <p parentName="li"><inlineCode parentName="p">{`curl -L https://raw.githubusercontent.com/IBM/spm-ui-upgrade-helper/main/docker-compose.yml -o docker-compose.yml`}</inlineCode></p>
        <p parentName="li">{`Linux ®️`}</p>
        <p parentName="li"><inlineCode parentName="p">{`curl -L https://raw.githubusercontent.com/IBM/spm-ui-upgrade-helper/main/docker-compose.yml -o docker-compose.yml`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run `}<inlineCode parentName="p">{`chmod -R 777 <output_folder>`}</inlineCode>{` so that Docker can interact with the temporary output folder. For example, `}<inlineCode parentName="p">{`C:\\temp\\upgrade`}</inlineCode>{` or `}<inlineCode parentName="p">{`/tmp/upgrade`}</inlineCode>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Set the required variables and run the batch file or shell script:`}</p>
 <InlineNotification mdxType="InlineNotification">
          <p parentName="li">{` Warning:  Do not point the output folder at your version 8 development environment as it is a temporary folder that is wiped each time that the UI Upgrade Helper runs.`}</p>
 </InlineNotification>
        <p parentName="li">{`Windows ™️`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-batch"
          }}>{`Set INPUT_FOLDER=\`<input_folder>\`
Set OUTPUT_FOLDER=\`<output_folder>\`
Set VERSION=\`<version>\`
spm-ui-upgrade-helper.bat
`}</code></pre>
        <p parentName="li">{`Linux ®️`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`export INPUT_FOLDER=\`<input_folder>
export OUTPUT_FOLDER=\`<output_folder>\`
export VERSION=\`<version>\` 
sh spm-ui-upgrade-helper.sh
`}</code></pre>
        <p parentName="li">{`Where:`}</p>
        <ul parentName="li">
          <li parentName="ul"><inlineCode parentName="li">{`VERSION`}</inlineCode>{` is the version of the tool on DockerHub -typically `}<inlineCode parentName="li">{`latest`}</inlineCode>{`.`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`INPUT_FOLDER`}</inlineCode>{` is the absolute path to the input files for the tool. Typically this is the Social Program Management installation folder, which by default is `}<inlineCode parentName="li">{`C:\\IBM\\Curam\\Development`}</inlineCode>{` or `}<inlineCode parentName="li">{`opt/IBM/Curam/Development`}</inlineCode>{`.`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`OUTPUT_FOLDER`}</inlineCode>{` is the absolute path to your temporary output folder. For example, `}<inlineCode parentName="li">{`C:\\temp\\upgrade`}</inlineCode>{` or `}<inlineCode parentName="li">{`/tmp/upgrade`}</inlineCode>{`.`}</li>
        </ul>
      </li>
    </ol>
    <h2>{`Run the tool and review the changes`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Open your browser to `}<a parentName="p" {...{
            "href": "http://localhost:3000/#/home/workspace"
          }}>{`http://localhost:3000/#/home/workspace`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Press the F1 key or Cmd + Shift + p.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Type “Run SPM UI Upgrade Helper” and click on the shortcut. The files in the `}<inlineCode parentName="p">{`input`}</inlineCode>{` folder are scanned and the results are placed in the `}<inlineCode parentName="p">{`output`}</inlineCode>{` folder.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Wait a few minutes for the tool to finish.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click the `}<inlineCode parentName="p">{`Source Control: Git`}</inlineCode>{` button on the left sidebar to inspect the changes.`}</p>
        <img parentName="li" {...{
          "src": "/spm-ui-upgrade-helper/d9be6be1041ad9537325beb9cef2a05a/upgrade-helper.gif",
          "alt": "1. Press F1, 2. Type \"Run SPM UI Upgrade Helper\", 3. Select the shortcut, 4. Wait for the tool to finish, 5. Click \"Source Control: Git\" to see the output",
          "title": "Running the UI Upgrade Helper tool"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`For more information about Window Size Tool changes, see `}<a parentName="p" {...{
            "href": "../../setup/tools#reviewing-window-size-tool-changes"
          }}>{`Reviewing Window Size Tool changes`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`When you are happy with the changes, copy the contents of the `}<inlineCode parentName="p">{`output`}</inlineCode>{` folder into your v8 development environment.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Build and test your v8 development environment.`}</p>
      </li>
    </ol>
    <h2>{`Errors`}</h2>
    <p>{`Docker container logs are available in the console, or by using `}<inlineCode parentName="p">{`docker logs spm-ui-upgrade-helper`}</inlineCode>{`.`}</p>
    <p>{`You can save the logs to a file. For example, by using `}<inlineCode parentName="p">{`docker logs spm-ui-upgrade-helper > /tmp/logs.txt`}</inlineCode>{`.`}</p>
    <h2>{`Troubleshooting`}</h2>
    <ul>
      <li parentName="ul">{`Ensure that you are logged in to Docker, (run `}<inlineCode parentName="li">{`docker login`}</inlineCode>{`).`}</li>
      <li parentName="ul">{`Ensure that the correct folders are shared in Docker Desktop.`}</li>
      <li parentName="ul">{`Restart Docker Desktop.`}</li>
      <li parentName="ul">{`Delete the `}<inlineCode parentName="li">{`<output_folder>`}</inlineCode>{` and try again.`}</li>
      <li parentName="ul">{`Make sure you have run `}<inlineCode parentName="li">{`chmod -R 777 <output_folder>`}</inlineCode>{` so that Docker can write to it.`}</li>
      <li parentName="ul">{`Don’t refresh `}<a parentName="li" {...{
          "href": "http://localhost:3000/#/home/workspace/output"
        }}>{`http://localhost:3000/#/home/workspace/output`}</a>{`, but go to `}<a parentName="li" {...{
          "href": "http://localhost:3000/#/home/workspace"
        }}>{`http://localhost:3000/#/home/workspace`}</a>{`.`}</li>
      <li parentName="ul">{`To kill the Docker container, use `}<inlineCode parentName="li">{`docker stop spm-ui-upgrade-helper`}</inlineCode>{` followed by `}<inlineCode parentName="li">{`docker rm spm-ui-upgrade-helper`}</inlineCode>{`.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      